/*
 * Public API Surface of google-maps-autocomplete
 */

export * from './lib/interfaces';
export * from './lib/component';
export * from './lib/directives/mat-google-maps-autocomplete.directive';
export * from './lib/directives/address-validator/mat-address-validator.directive';
export * from './lib/mat-google-maps-autocomplete.module';

